import { strings } from "../constants/strings";

export function pickKey(key) {
  const HOST_NAME = window.location.hostname;
  let srt
  let rt
  if('Subscriptions_Description') {
    srt = strings.Subscriptions_Description_Canada;    
    rt = strings.Subscriptions_Description;
  }
  if (HOST_NAME.includes('speed')) {
    return srt;
  } else {
    return rt;
  }
}